import React, { Component } from 'react';
import PropTypes from 'prop-types';

import SrSwipe from 'client/components/SrSwipe';
import ListingCard from 'client/components/ListingCard';

export const translate3d = (x, y) => {
  const translate = `translate3d(${x}px, ${y}px, 0px)`;
  return {
    msTransform: translate,
    WebkitTransform: translate,
    transform: translate,
  };
};

class SrSwipeableListingCard extends Component {
  static propTypes = {
    listing: PropTypes.object,
    currentUser: PropTypes.object,
    onSwipe: PropTypes.func.isRequired,
    agentTourId: PropTypes.number,
    adminTourId: PropTypes.number,
    photoResolution: PropTypes.number.isRequired,
  }

  constructor() {
    super();

    this.state = {
      scrollY: 0,
    };
  }

  _onSwipeEnd = () => {
    const { onSwipe } = this.props;
    const { scrollY } = this.state;
    const deltaY = 70;

    if (scrollY > deltaY) {
      onSwipe();
      setTimeout(() => {
        this.setState({ scrollY: 0 });
      }, 300);
    }
  }

  _onSwipe = (e) => {
    this.setState({
      scrollY: e[1] < 0 ? 0 : e[1],
    });
  }

  render() {
    const {
      listing,
      currentUser,
      agentTourId,
      adminTourId,
      photoResolution,
    } = this.props;

    const {
      scrollY,
    } = this.state;

    if (!listing) {
      return null;
    }

    return (
      <div className='swipeContainerMap'>
        <SrSwipe onSwipeEnd={this._onSwipeEnd} onSwipe={this._onSwipe}>
          <div
            style={{ draggable: true }}
            className='listingCardContainerMap'
          >
            <ListingCard
              enableBookmarkButton
              style={{ ...translate3d(0, scrollY) }}
              listing={listing}
              currentUser={currentUser}
              agentTourId={agentTourId}
              adminTourId={adminTourId}
              photoResolution={photoResolution}
            />
          </div>
        </SrSwipe>
      </div>
    );
  }
}

SrSwipeableListingCard.displayName = 'SrSwipeableListingCard';

export default SrSwipeableListingCard;
